/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_NoInputs */

const vi_shop_no = /** @type {(inputs: Shop_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không`)
};

/**

* @param {Shop_NoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_no = /** @type {((inputs?: Shop_NoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_NoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_no(inputs)
});